export default __webpack_public_path__ + "static/media/logo.57b1443f.png";